// extracted by mini-css-extract-plugin
export default {"expenseHeader":"ExpenseDetail_expenseHeader__+pBZn","expenseTitle":"ExpenseDetail_expenseTitle__UzYJy","label":"ExpenseDetail_label__KVL-z","text":"ExpenseDetail_text__Bk6+p"};